// Animation durations in seconds
export const SESSION_ANIMATION_DURATIONS = {
  LAYOUT_TRANSITION: 0.3,
  HEADER_TEXT_FADE: 0.2,
  CONTENT_COLLAPSE: 0.1,
} as const;

// Y-axis offsets for header text animations
export const SESSION_HEADER_ANIMATION_OFFSETS = {
  ENTER_FROM_TOP: -8,
  EXIT_TO_BOTTOM: 8,
} as const;

// Text displayed in various UI states
export const SESSION_THOUGHT_PROCESS_TEXTS = {
  THINKING: "Thinking...",
  PROCESSING: "Processing...",
  SHOW_COLLAPSED: "Show thought process",
  HIDE_EXPANDED: "Hide thought process",
} as const;

// Text truncation settings
export const SESSION_TEXT_DISPLAY_CONFIG = {
  MAX_HEADER_LENGTH: 50,
  TRUNCATION_SUFFIX: "...",
  TRUNCATION_BUFFER: 3,
} as const;

// Stagger delay between event animations
export const SESSION_EVENT_FADE_IN_DELAY = 0.1;
